module.exports = __webpack_public_path__ + "static/media/large_platform.e3a106da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/gameSpacePort/large_platform.png
// module id = 2479
// module chunks = 0